import { startHolyLoader } from "holy-loader"
import { useRouter, useSearchParams } from "next/navigation"

type AvailableFilters = "query"

/**
 * Set the value to null to remove it.
 */
type AvailableFiltersValues = Partial<Record<AvailableFilters, string | null>>

const availableFilterNames: AvailableFilters[] = ["query"]

export function useJobsFilters(): {
  navigateWithUpdatedQueryParams: (availableFilters: AvailableFiltersValues) => void
} {
  const { push } = useRouter()
  const nextSearchParams = useSearchParams()
  const updatedSearchParams = new URLSearchParams(nextSearchParams)

  function navigateWithUpdatedQueryParams(availableFilters: AvailableFiltersValues): void {
    updatedSearchParams.delete("page")

    availableFilterNames.forEach(availableFilterName => {
      const value = availableFilters[availableFilterName]

      if (value && Array.isArray(value)) {
        updatedSearchParams.delete(availableFilterName)
        value.forEach(singleValue => {
          if (singleValue) {
            updatedSearchParams.append(availableFilterName, singleValue)
          }
        })
      } else if (value) {
        updatedSearchParams.set(availableFilterName, value)
      } else if (updatedSearchParams.has(availableFilterName) && value === null) {
        updatedSearchParams.delete(availableFilterName)
      }
    })

    startHolyLoader()
    push(`?${updatedSearchParams.toString()}`)
  }

  return {
    navigateWithUpdatedQueryParams,
  }
}
